import { handleActions } from '@housinganywhere/safe-redux';

import { Actions, ActionTypes } from '../actions/getCities';
import { City } from 'ha/services/apiV2/types';

interface State {
  list: City[];
  error: boolean;
}

export const initialState: State = {
  list: [],
  error: false,
};

export default handleActions<State, ActionTypes, Actions>(
  {
    [ActionTypes.START]: state => ({
      ...state,
      error: false,
    }),
    [ActionTypes.DONE]: (state, { payload }) => ({
      ...state,
      list: payload,
    }),
    [ActionTypes.FAIL]: state => ({
      ...state,
      error: true,
    }),
  },
  initialState,
);
